import { render } from "./WelcomeMessage.vue?vue&type=template&id=6e201f45&scoped=true&ts=true"
import script from "./WelcomeMessage.vue?vue&type=script&lang=ts"
export * from "./WelcomeMessage.vue?vue&type=script&lang=ts"

import "./WelcomeMessage.vue?vue&type=style&index=0&id=6e201f45&lang=scss&scoped=true"

import exportComponent from "/home/cretzler/source/Contributr-v2/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e201f45"]])

export default __exports__